import { DocumentNode, gql } from '@apollo/client';
import * as React from 'react';

import { Sponsorships_EventFragment } from './graphql-types/Sponsorships_EventFragment';

import { ConferenceEventSponsor } from './ConferenceEventSponsor';
import { SimpleEventSponsor } from './SimpleEventSponsor';

export const Sponsorships: React.FC<{
  isHtml: boolean;
  event: Sponsorships_EventFragment;
}> & {
  eventFragment: DocumentNode;
} = (props) => {
  const sponsors =
    props.event.__typename === 'ConferenceEventV2'
      ? props.event.conferenceSponsors
      : props.event.simpleEventSponsors;

  if (!sponsors) {
    return null;
  }

  if (
    props.event?.__typename === 'SimpleEventV2' &&
    props.event.simpleEventSponsors?.keySponsor
  ) {
    return (
      <>
        {props.isHtml ? (
          <h2>Sponsors:</h2>
        ) : (
          <>
            Sponsors:
            <br />
          </>
        )}

        <SimpleEventSponsor
          sponsor={props.event.simpleEventSponsors.keySponsor}
          isHtml={props.isHtml}
        />
        {props.event.simpleEventSponsors.additionalSponsors
          ? props.event.simpleEventSponsors.additionalSponsors.map(
              (additionalSponsor) => (
                <SimpleEventSponsor
                  key={additionalSponsor._id}
                  sponsor={additionalSponsor}
                  isHtml={props.isHtml}
                />
              )
            )
          : null}
      </>
    );
  }

  const conferenceEventSponsorships =
    (props.event?.__typename === 'ConferenceEventV2' &&
      props.event.conferenceSponsors) ||
    undefined;
  const countConferenceEventSponsorships =
    (conferenceEventSponsorships?.firstTierSponsors.length || 0) +
    (conferenceEventSponsorships?.secondTierSponsors.length || 0) +
    (conferenceEventSponsorships?.thirdTierSponsors.length || 0);

  if (
    props.event?.__typename === 'ConferenceEventV2' &&
    countConferenceEventSponsorships > 0
  ) {
    return (
      <>
        {props.isHtml ? (
          <h2>Sponsors:</h2>
        ) : (
          <>
            Sponsors:
            <br />
          </>
        )}

        {conferenceEventSponsorships?.firstTierSponsors?.length && (
          <ConferenceEventSponsor
            sponsors={conferenceEventSponsorships.firstTierSponsors}
            eventSponsorshipTiersName={
              props.event.sponsorshipTierNames.firstTier
            }
            isHtml={props.isHtml}
          />
        )}

        {conferenceEventSponsorships?.secondTierSponsors?.length && (
          <ConferenceEventSponsor
            sponsors={conferenceEventSponsorships.secondTierSponsors}
            eventSponsorshipTiersName={
              props.event.sponsorshipTierNames.secondTier
            }
            isHtml={props.isHtml}
          />
        )}

        {conferenceEventSponsorships?.thirdTierSponsors?.length && (
          <ConferenceEventSponsor
            sponsors={conferenceEventSponsorships.thirdTierSponsors}
            eventSponsorshipTiersName={
              props.event.sponsorshipTierNames.thirdTier
            }
            isHtml={props.isHtml}
          />
        )}
      </>
    );
  }

  return null;
};

Sponsorships.eventFragment = gql`
  fragment Sponsorships_EventFragment on EventV2 {
    _id
    ... on SimpleEventV2 {
      _id
      simpleEventSponsors {
        keySponsor {
          ...SimpleEventSponsor_OrganizationFragment
        }
        additionalSponsors {
          ...SimpleEventSponsor_OrganizationFragment
        }
      }
    }
    ... on ConferenceEventV2 {
      _id
      sponsorshipTierNames {
        firstTier
        secondTier
        thirdTier
      }
      conferenceSponsors {
        firstTierSponsors {
          _id
          ...ConferenceEventSponsor_OrganizationFragment
        }
        secondTierSponsors {
          _id
          ...ConferenceEventSponsor_OrganizationFragment
        }
        thirdTierSponsors {
          _id
          ...ConferenceEventSponsor_OrganizationFragment
        }
      }
    }
  }
  ${SimpleEventSponsor.sponsorFragment}
  ${ConferenceEventSponsor.sponsorFragment}
`;
